<script setup lang="ts">
import PrimaryButton from '@/components/buttons/general/PrimaryButton.vue'
import useAuthStore from '@/stores/auth'
import Toasts from '@/util/toasts'

const authStore = useAuthStore()

const goToLogin = async () => {
  const relativePath = window.location.pathname + window.location.search;
  sessionStorage.setItem('redirectUrl', relativePath);
  try {
    window.location.href = await authStore.generateLoginUrl()
  } catch (err) {
    Toasts.Error('Cannot start sign-in; See console for details')
    console.error(err)
  }
}
</script>

<template>
  <PrimaryButton
    :loading="authStore.loading"
    class="!rounded-sm w-44 !bg-[#337ab7] !border-[#337ab7]"
    @click="goToLogin"
  >
    <span class="font-extrabold">Sign in</span>
  </PrimaryButton>
</template>

<style scoped></style>
